import React from 'react';

import AddIcon from 'icons/add.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import RowBar from 'components/application/RowBar';
import SearchField from 'components/application/SearchField';

import { useTrainingRegisterResources } from 'components/contexts/TrainingRegisterResourceManagementContext';

export default function RolesBar({
  isSearchDisabled,
  onAddClick,
  onSearchInputChange,
  onSearchReset,
  rolesSearch,
}) {
  const { hasRoleEditableAccess } = useTrainingRegisterResources();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'roles.RolesBar',
  });

  const { t: i18nTRoles } = useTranslation('common', {
    keyPrefix: 'roles',
  });

  return (
    <RowBar
      actions={
        hasRoleEditableAccess && (
          <OutlinedButton color='grey' onClick={onAddClick} size='sm'>
            <AddIcon className='-tw-ml-2' height={24} width={24} />
            <span>{i18nTRoles('addNewRole')}</span>
          </OutlinedButton>
        )
      }
      content={
        <SearchField
          additionalClasses='search-field__lg'
          isDisabled={isSearchDisabled}
          name='rolesSearch'
          onChange={onSearchInputChange}
          onReset={onSearchReset}
          placeholder={i18nT('search.placeholder')}
          value={rolesSearch}
        />
      }
      modifiers={[
        'border-top-curved',
        'border-bottom-none',
        'flex-align-items-ie-fix',
      ]}
    />
  );
}

RolesBar.propTypes = {
  isSearchDisabled: PropTypes.bool,
  onAddClick: PropTypes.func.isRequired,
  onSearchInputChange: PropTypes.func.isRequired,
  onSearchReset: PropTypes.func.isRequired,
  rolesSearch: PropTypes.string,
};
